"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const CustomerInterface_1 = require("../../../BusinessLogicLayer/CustomerInterface");
const exception_1 = require("@almservices-cl/exception");
const dateComparison_1 = __importDefault(require("../../../Util/dateComparison"));
const asString_1 = __importDefault(require("../../../Util/asString"));
const period_to_subscription_mapper_1 = require("@almservices-cl/period-to-subscription-mapper");
const map = new Map();
map.set("neck", [
    CustomerInterface_1.NECK_CHARACTERISTIC.SHORT,
    CustomerInterface_1.NECK_CHARACTERISTIC.IN_PROPORTION,
    CustomerInterface_1.NECK_CHARACTERISTIC.LANG,
]);
map.set("shoulders", [
    CustomerInterface_1.SHOULDERS_CHARACTERISTIC.NARROW,
    CustomerInterface_1.SHOULDERS_CHARACTERISTIC.IN_PROPORTION,
    CustomerInterface_1.SHOULDERS_CHARACTERISTIC.WIDE,
]);
map.set("upperarms", [
    CustomerInterface_1.UPPER_ARMS_CHARACTERISTIC.THIN,
    CustomerInterface_1.UPPER_ARMS_CHARACTERISTIC.MUSCULAR,
    CustomerInterface_1.UPPER_ARMS_CHARACTERISTIC.FIRM,
]);
map.set("breastM", [
    CustomerInterface_1.BREAST_CHARACTERISTIC.NO_CHEST,
    CustomerInterface_1.BREAST_CHARACTERISTIC.MUSCULAR_CHEST,
    CustomerInterface_1.BREAST_CHARACTERISTIC.FEMALE_CHEST,
]);
map.set("breastF", [
    CustomerInterface_1.BREAST_CHARACTERISTIC.SMALL,
    CustomerInterface_1.BREAST_CHARACTERISTIC.IN_PROPORTION,
    CustomerInterface_1.BREAST_CHARACTERISTIC.LARGE,
]);
map.set("belly", [
    CustomerInterface_1.BELLY_CHARACTERISTIC.FLAT,
    CustomerInterface_1.BELLY_CHARACTERISTIC.MUSCULAR,
    CustomerInterface_1.BELLY_CHARACTERISTIC.FIRM,
]);
map.set("legs", [
    CustomerInterface_1.LEGS_CHARACTERISTIC.THIN,
    CustomerInterface_1.LEGS_CHARACTERISTIC.MUSCULAR,
    CustomerInterface_1.LEGS_CHARACTERISTIC.FIRM,
]);
map.set("waist", [
    CustomerInterface_1.WAIST_CHARACTERISTIC.NO_LOVE_HANDLES,
    CustomerInterface_1.WAIST_CHARACTERISTIC.IN_PROPORTION,
    CustomerInterface_1.WAIST_CHARACTERISTIC.WELL_LOVE_HANDLES,
]);
map.set("lovehandles", [
    CustomerInterface_1.LOVE_HANDLES_CHARACTERISTIC.NARROW,
    CustomerInterface_1.LOVE_HANDLES_CHARACTERISTIC.IN_PROPORTION,
    CustomerInterface_1.LOVE_HANDLES_CHARACTERISTIC.WIDE,
]);
map.set("buttocks", [
    CustomerInterface_1.BUTTOCKS_CHARACTERISTIC.FLAT,
    CustomerInterface_1.BUTTOCKS_CHARACTERISTIC.MUSCULAR,
    CustomerInterface_1.BUTTOCKS_CHARACTERISTIC.FIRM,
]);
map.set("calves", [
    CustomerInterface_1.CALVES_CHARACTERISTIC.THIN,
    CustomerInterface_1.CALVES_CHARACTERISTIC.MUSCULAR,
    CustomerInterface_1.CALVES_CHARACTERISTIC.FIRM,
]);
const translate = (type, value, gender) => {
    const pos = ["SMALL", "MEDIUM", "LARGE"].indexOf(value);
    if (type === "breast") {
        return map.get(type + gender)[pos];
    }
    return map.get(type)[pos];
};
class CustomerListAdapter {
    constructor(systemDateTimeProvider, dateTimeModifier, dateTimeBridge) {
        this.remainingHoursToDateTime = (timezone, hours) => {
            return this.dateTimeModifier.modifyHours(this.systemDateTimeProvider.currentRaw(timezone).date, hours, timezone);
        };
        this.adaptCustomerItem = ({ id, galleryId, isNew, hasUpgraded, hasUpgradedToCoaching, firstName, lastName, address: { streetName, city, streetNumber, postCode }, birthDate, phoneNumber, currentPeriod, periods, email, responseDeadline, lastActivity, hasUnseenMeal, hasUnreadMessage, hasUnseenTraining, hasUnseenRecovery, hasUnseenBehaviour, hasUnseenMeasurement, hasUnseenLife, hasUnseenMind, nutritionMethod, isProlonger, atLeastOneNewTag, hasChangedCoach, isRejoiner, absoluteDay, }) => {
            const convertedPeriods = periods.map((p) => (0, period_to_subscription_mapper_1.RawPeriodToPeriodAdapter)(p));
            const currentSubscriptionPeriods = convertedPeriods
                .filter((s) => s.subscriptionId === currentPeriod.subscriptionId)
                .sort();
            const periodStartDates = this.periodStartDates(currentSubscriptionPeriods);
            const periodEndDates = this.periodEndDates(currentSubscriptionPeriods);
            return {
                id: id.toString(),
                galleryId,
                firstName,
                lastName,
                address: {
                    street: (0, asString_1.default)(streetName),
                    localeNumber: (0, asString_1.default)(streetNumber),
                    city: (0, asString_1.default)(city),
                    postalCode: (0, asString_1.default)(postCode),
                },
                birthDate,
                phoneNumber,
                lastActive: lastActivity,
                isIntakeDone: currentPeriod.hasIntake,
                email,
                period: {
                    dateOfPeriodStart: periodStartDates[0],
                    dateOfPeriodEnd: periodEndDates[periodStartDates.length - 1],
                    length: periodStartDates.length * 6,
                },
                subscriptionPeriod: (0, period_to_subscription_mapper_1.RawPeriodToPeriodAdapter)(currentPeriod),
                periods: convertedPeriods,
                isNew,
                responseDeadLine: (responseDeadline === null || responseDeadline === void 0 ? void 0 : responseDeadline.iso8601) || null,
                hasUpgraded,
                hasUpgradedToCoaching,
                plan: {
                    name: currentPeriod.plan.name,
                },
                notifications: {
                    hasUnseenMeal,
                    hasUnreadMessage,
                    hasUnseenTraining,
                    hasUnseenRecovery,
                    hasUnseenBehaviour,
                    hasUnseenMeasurement,
                    hasUnseenLife,
                    hasUnseenMind,
                },
                trainingLocation: {
                    placeName: currentPeriod.trainingLocation.placeName,
                    gymName: currentPeriod.trainingLocation.details,
                },
                code: currentPeriod.code,
                method: nutritionMethod === "hand" ? "handpalm" : "caloriecount",
                isProlonger: !!isProlonger,
                hasNewCoach: !!hasChangedCoach,
                hasRejoined: !!isRejoiner,
                atLeastOneNewTag: !!atLeastOneNewTag,
                absoluteDay,
            };
        };
        this.adaptIntake = (intake) => {
            const gender = this.gender(intake.period.code.gender);
            return {
                disc: {
                    d: this.intakeScoreByName(intake.disc, "D").value,
                    i: this.intakeScoreByName(intake.disc, "I").value,
                    s: this.intakeScoreByName(intake.disc, "S").value,
                    c: this.intakeScoreByName(intake.disc, "C").value,
                },
                hormone: intake.hormone,
                bodyCharacteristics: {
                    neck: this.bodyCharacteristics("neck", intake.bodyFeatures, gender),
                    shoulders: this.bodyCharacteristics("shoulders", intake.bodyFeatures, gender),
                    upperArms: this.bodyCharacteristics("upperarms", intake.bodyFeatures, gender),
                    chest: this.bodyCharacteristics("breast", intake.bodyFeatures, gender),
                    belly: this.bodyCharacteristics("belly", intake.bodyFeatures, gender),
                    hips: this.bodyCharacteristics("legs", intake.bodyFeatures, gender),
                    waist: this.bodyCharacteristics("waist", intake.bodyFeatures, gender),
                    loveHandles: this.bodyCharacteristics("lovehandles", intake.bodyFeatures, gender),
                    buttocks: this.bodyCharacteristics("buttocks", intake.bodyFeatures, gender),
                    calves: this.bodyCharacteristics("calves", intake.bodyFeatures, gender),
                },
                trainingExperience: intake.trainingExperience,
                nutritionExperience: intake.nutritionExperience,
                questions: intake.extraQuestions,
                xQuestions: this.adaptXPlanQuestions(intake.xPlanQuestions),
            };
        };
        this.bodyCharacteristics = (name, bodyFeatures, gender) => {
            const bodyFeature = bodyFeatures.find((bodyFeature) => bodyFeature.name === name);
            return translate(name, bodyFeature === null || bodyFeature === void 0 ? void 0 : bodyFeature.size, gender);
        };
        this.intakeScoreByName = (intakeScores, name) => {
            for (const intakeScore of intakeScores) {
                if (intakeScore.name === name) {
                    return intakeScore;
                }
            }
            throw new exception_1.OutOfRangeException(`Intake Score of name "${name}" was not found`);
        };
        this.periodStartDates = (periodSubscriptions) => periodSubscriptions.map(({ startDate }) => startDate).sort(dateComparison_1.default);
        this.periodEndDates = (periodSubscriptions) => periodSubscriptions.map(({ endDate }) => endDate).sort(dateComparison_1.default);
        this.numberOfCoachingDays = (model) => {
            switch (model) {
                case "premium":
                    return null;
                case "plus":
                    return 3;
                case "original":
                    return 1;
            }
        };
        this.adaptXPlanQuestions = (xqas) => {
            return xqas.map((xqa) => {
                if (xqa.answer == null) {
                    return xqa;
                }
                try {
                    const data = JSON.parse(xqa.answer);
                    if (data.type === "date") {
                        return {
                            ...xqa,
                            answer: this.dateTimeBridge.userDate(data.date),
                        };
                    }
                }
                catch (SyntaxError) {
                    // ignore
                }
                return xqa;
            });
        };
        this.systemDateTimeProvider = systemDateTimeProvider;
        this.dateTimeModifier = dateTimeModifier;
        this.dateTimeBridge = dateTimeBridge;
    }
    gender(gender) {
        switch (gender) {
            case "FEMALE":
                return "F";
            case "MALE":
                return "M";
        }
    }
}
exports.default = CustomerListAdapter;
//# sourceMappingURL=CustomerListAdapter.js.map